import { get, isEmpty } from "lodash";

import { AppConfigs } from "../models/AppConfigs";
import { initAfterConfigLoad } from "../utils";
import { AppEnvironmentConfig } from "./AppConfigs";

const assignConfigs = (data: Partial<AppConfigs>) => {
  configs = { ...configs, ...data };
  configUrl = configs.REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_RR;
  documentMaxSize = configs.REACT_APP_REFERRAL_REQUEST_DOCUMENT_MAX_SIZE;
  googleMapKey = configs.REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_KEY;
  googleMapUrl = configs.REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_API_URL;
  privacyPracticeUrl = configs.REACT_APP_REFERRAL_REQUEST_PRIVACY_PRACTICE_URL;
  providerPortalUrl = configs.REACT_APP_REFERRAL_REQUEST_PROVIDER_PORTAL_URL;
  providerRelationEmail =
    configs.REACT_APP_REFERRAL_REQUEST_PROVIDER_RELATION_EMAIL;
  reactAppDebug = configs.REACT_APP_REFERRAL_REQUEST_DEBUG === 1;
  documentMinSize = !isEmpty(
    configs.REACT_APP_REFERRAL_REQUEST_DOCUMENT_MIN_SIZE
  )
    ? configs.REACT_APP_REFERRAL_REQUEST_DOCUMENT_MIN_SIZE
    : "1KB";
  initAfterConfigLoad();
};

export const updateConfigs = (data: Partial<AppConfigs>) => {
  assignConfigs(data);
};

export const updateVariables = (variables: Partial<AppConfigs>) => {
  assignConfigs(variables);
};

export let configs: AppConfigs = {
  REACT_APP_REFERRAL_REQUEST_REPLACE_START: "",
  REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_KEY: "",
  REACT_APP_REFERRAL_REQUEST_DOCUMENT_MAX_SIZE: "",
  REACT_APP_REFERRAL_REQUEST_DOCUMENT_MIN_SIZE: "",
  REACT_APP_REFERRAL_REQUEST_DEBUG: false,
  REACT_APP_REFERRAL_REQUEST_APPINSIGHTS_CONNECTION_STRING: "",
  REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_API_URL: "",
  REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL: "",
  REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_CHECK_ELIGIBILITY: "",
  REACT_APP_REFERRAL_REQUEST_FAX_MAX_SIZE: "",
  REACT_APP_REFERRAL_REQUEST_IS_PRODUCTION_ENV: 0,
  REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_RR: "",
  REACT_APP_REFERRAL_REQUEST_PRIVACY_PRACTICE_URL: "",
  REACT_APP_REFERRAL_REQUEST_PROVIDER_PORTAL_URL: "",
  REACT_APP_REFERRAL_REQUEST_PROVIDER_RELATION_EMAIL: "",
  REACT_APP_REFERRAL_REQUEST_REPLACE_END: "",
};
export let googleMapKey = configs.REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_KEY;
export let googleMapUrl = configs.REACT_APP_REFERRAL_REQUEST_GOOGLE_MAP_API_URL;
export let reactAppDebug = configs.REACT_APP_REFERRAL_REQUEST_DEBUG as boolean;
export let documentMaxSize =
  configs.REACT_APP_REFERRAL_REQUEST_DOCUMENT_MAX_SIZE;
export let documentMinSize =
  configs.REACT_APP_REFERRAL_REQUEST_DOCUMENT_MIN_SIZE;
export let configUrl = configs.REACT_APP_REFERRAL_REQUEST_HOST_CONFIG_URL_RR;
export let privacyPracticeUrl =
  configs.REACT_APP_REFERRAL_REQUEST_PRIVACY_PRACTICE_URL;
export let providerPortalUrl =
  configs.REACT_APP_REFERRAL_REQUEST_PROVIDER_PORTAL_URL;
export let providerRelationEmail =
  configs.REACT_APP_REFERRAL_REQUEST_PROVIDER_RELATION_EMAIL;

/* Config from build-time variables - END */

/* App level config constants - START */

//Check if running as localhost
export const IS_LOCALHOST: boolean =
  get(process.env, "NODE_ENV", "") === AppEnvironmentConfig.DEV;

//Applied endpoint for localhost -> can be changed via CLI e.g. set REACT_APP_ENDPOINT_ENV=SB
export const REACT_APP_ENDPOINT_ENV = get(
  process.env,
  "REACT_APP_ENDPOINT_ENV",
  ""
);

/* App level config constants - END */
